'use strict';

import $ from 'jquery';

//import productList from './product-list';
//import productPage from './product-page';
//import productPackage from './product-package';
//import packageBuilder from './package-builder';
import productReviews from './product-reviews';

export default function(API) {
	$(document).ready(() => {

		API.log('INIT Product');

		// Init product lists globally

		if( $('.product-grid').length ){

			import('./product-list').then(({ default: productList }) => {
				productList();
				console.log('IMPORT product grid');
			});

		}

		if( $('.product-carousel').length ){

			import('./product-carousel').then(({ productCarousel: carousel }) => {
				carousel('.product-carousel');
				console.log('IMPORT carousel');
			});

		}

		productReviews();

		// Init product cards
		const products = $('.v4-product-card');
		if( $('.package-builder').length ) {

			import('./package-builder').then(({ default: packageBuilder }) => {
				packageBuilder();
				console.log('IMPORT package builder');
			});

		} else if( $('.product-package').length ) {

			import('./product-page').then(({ default: productPage }) => {
				products.each((index, el) => productPage($(el)));
				console.log('IMPORT product page');
			});

			import('./product-package').then(({ default: productPackage }) => {
				productPackage();
				console.log('IMPORT product package');
			});

		} else if( $('.v4-product').length ){

			import('./product-page').then(({ default: productPage }) => {
				productPage(products);
				console.log('IMPORT product page');
			});

		}

		if ($('.form-leasing').length) {
			import('./leasing').then(({ default: leasing }) => {
				leasing();
			});
		}

	});
}
